import { Box, styled } from '@mui/system';
import { Typography } from '@mui/material';

export const HorizontalContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  maxWidth: '1200px',
  gap: '22px',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '0',
  },
  [theme.breakpoints.up('lg')]: {
    gap: '40px',
  },
}));

export const CheckoutCardsContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'desktopPadding',
})<{ desktopPadding?: string }>(({ theme, desktopPadding }) => ({
  maxWidth: '800px',
  width: '100%',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  padding: '16px',
  gap: '16px',
  backgroundColor: 'inherit',
  border: 'none',
  [theme.breakpoints.up('sm')]: {
    padding: desktopPadding ?? '24px',
    gap: desktopPadding ?? '24px',
  },
}));

export const TitleTypography = styled(Typography)({
  fontWeight: 600,
  fontSize: '18px',
  lineHeight: '27px',
  letterSpacing: '0.15px',
});

export const SubtitleTypography = styled(Typography)({
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '100%',
  letterSpacing: '0.15px',
  padding: '8px',
});

export const ErrorTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '16px',
  letterSpacing: '0.15px',
  color: theme.palette.error.main,
}));
